/* Constants
======================================== */
const body = $('body');
const easing = $.bez([0.80, 0, 0.20, 1]);
const timing = 300;
const isMobile = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

/* Credits
======================================== */
console.log(body.data('theme') + ': code by Carlos Mayo (https://carlosmayo.info/)');

/* Device detection
======================================== */
isMobile ? body.addClass('devices') : body.addClass('desktop');

/* Scroll Top
======================================== */
if ('scrollRestoration' in history) {
	history.scrollRestoration = 'manual';
	window.scrollTo(0,0);
}

/* Height viewport
======================================== */
function heightViewport() {
	const wh = window.innerHeight + 'px';
	if (document.documentElement.style.getPropertyValue('--height-viewport') !== wh) {
		document.documentElement.style.setProperty('--height-viewport', wh);
	}
}
if (isMobile) {
	document.addEventListener('touchstart', () => {}, { passive: true });
	window.addEventListener('orientationchange', () => {
		setTimeout(heightViewport, 100); /* !!! alguna forma sin setTimeout? */
	});
} else {
	window.addEventListener('resize', heightViewport);
}
heightViewport();

/* Init
======================================== */
setTimeout(() => {
	$('#loader').fadeOut(timing*2, function () {
		$(this).addClass('completed');
		body.removeClass('transition');
	});
}, timing*2);

/* Handle transitions
======================================== */
function checkTransition(target) {
	if (!$(target).hasClass('transition')) {
		$(target).addClass('transition');
		return true;
	}
	return false;
}

/* Observer: videos
======================================== */
let observerVideos;
const initObserverVideos = (target) => {
	observerVideos = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			const video = entry.target;
			if (entry.isIntersecting) {
				video.play()
					.then(() => {
						$(video).removeClass('lazy lazyvideo').addClass('lazyloaded');
					})
					.catch(() => {
						$(video).removeClass('lazy lazyvideo').addClass('lazyloaded');
						observerVideos.unobserve(video);
					});
			} else {
				if (!video.paused && video.classList.contains('lazyloaded')) { /* !!! revisar */
					if (!video.classList.contains('sound-active')) {
						video.pause();
					}
				}
			}
		});
	});
	document.querySelectorAll(target).forEach(video => {
		observerVideos.observe(video);
	});
}
document.querySelector('video.lazy') && initObserverVideos('video.lazy');